
// React imports
import React, { useState } from "react";

// component imports
import Logo from "../components/design/Logo";
import TextField from "../components/text/TextField";

// css styles & Assets
import '../styles/contact/ContactQuotes.css';
import jean from '../images/headshots/jean-nicolas.png';
import jad from '../images/headshots/jadkhalil.png';


const quoteData = [
    {
        company: "NicheWare",
        logo: null, // if null just use NicheWare logo otherwise use the company Logo
        quote: `Working for Auburn Bay, I saw an opportunity to improve the way we operate within our community. 
                I wanted to create a platform that would make daily operations easier for both residents and the board.`,
        signature: "Jean-Nicolas Rouette",
        role: "Co-Founder & CEO",
        author: jean,
    },
    {
        company: "NicheWare",
        logo: null, // if null just use NicheWare logo otherwise use the company Logo
        quote: `Living in Auburn bay I saw first hand the unecessary inoficiences that could be solved through strong
                communication and user friendly software.`,
        signature: "Jad Khalil",
        role: "Co-Founder & CTO",
        author: jad,
    }
];

const ContactQuotes = () => {

    const [activeIndex, setActiveIndex] = useState(0);
    // Tracks which way the page should turn: 1 = next (slide in from the
    // right), -1 = previous (slide in from the left).
    const [direction, setDirection] = useState(1);

    const activeQuote = quoteData[activeIndex];

    function goToPrevious() {
        setDirection(-1);
        setActiveIndex((prevIndex) => (prevIndex === 0 ? quoteData.length - 1 : prevIndex - 1));
    }

    function goToNext() {
        setDirection(1);
        setActiveIndex((prevIndex) => (prevIndex === quoteData.length - 1 ? 0 : prevIndex + 1));
    }

    function goToIndex(index) {
        setDirection(index > activeIndex ? 1 : -1);
        setActiveIndex(index);
    }
    
    return (
        <>
            <div className="contact-quote-card-container">

                <div
                    key={activeIndex}
                    className={`contact-quote-card-flip ${direction === 1 ? 'slide-next' : 'slide-prev'}`}
                >

                    {/* Quote Header -- If quote.logo is null use NicheWare logo */}
                    <div className="contact-quote-header">
                        {!activeQuote.logo && (
                            <Logo variant="full" size="small" />
                        )}
                    </div>

                    <div className="contact-quote-body">
                        <TextField text={'"' + activeQuote.quote + '"'} bold={true} fontSize={"0.95rem"} fontColor={"#000000"} />
                    </div>

                    <div className="contact-quote-footer">
                        <div className="contact-quote-author-headshot">
                            <img src={activeQuote.author} alt={activeQuote.signature} />
                        </div>

                        <div className="contact-quote-author-info">
                            <p>{activeQuote.signature}</p>
                            <p>{activeQuote.role}</p>
                        </div>
                    </div>

                </div>

            </div>

            <div className="contact-quote-selector">

                <div className="contact-quote-selector-bars">
                    {quoteData.map((quote, index) => (
                        <button
                            key={index}
                            type="button"
                            aria-label={`Show testimonial ${index + 1}`}
                            className={`contact-quote-selector-bar${index === activeIndex ? ' active' : ''}`}
                            onClick={() => goToIndex(index)}
                        />
                    ))}
                </div>

                <div className="contact-quote-selector-arrows">
                    <button
                        type="button"
                        aria-label="Previous testimonial"
                        className="contact-quote-selector-arrow"
                        onClick={goToPrevious}
                    >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M15 6l-6 6 6 6" />
                        </svg>
                    </button>
                    <button
                        type="button"
                        aria-label="Next testimonial"
                        className="contact-quote-selector-arrow"
                        onClick={goToNext}
                    >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M9 6l6 6-6 6" />
                        </svg>
                    </button>
                </div>

            </div>
        </>
    );
}


export default ContactQuotes;
